<template>
  <div class="album">
    <tip></tip>
    <template v-if="aciObj.enable">
      <empty></empty>
    </template>
    <template v-else>
      <audioTitle class="audioTitle" url="/audioList" :aciObj="aciObj"></audioTitle>
      <div class="conntent" v-if="!isData">
        <div class="video_btnn">
          <div class="video_count">
            共{{aciObj.audio_totals}}条音频
          </div>
          <div class="palyall">
            <div v-if="!palyIng" @click="playAllFn">
              <img src="../../assets/img/btnbofang.png" alt="">
              <span>播放全部</span>
            </div>
            <div v-else @click="pauseFn(albumsList[outIndex].list[index])">
              <img src="../../assets/img/benzanting.png" alt="">
              <span>暂停播放</span>
            </div>
          </div>
          <div class="buylink" v-if="aciObj.buy_link" @click="toBuy(aciObj.buy_link)">
            <div >
              <span>{{ aciObj.buy_title || '购买此书' }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="video-list">
        <div class="audio-album" v-for="(aci, k) in albumsList" :key="aci.id">
          <p class="album-title">
            <span @click="topageList(aci.id)">{{aci.name}}</span>
          </p>
          <span class="album-btn">
          <img v-if="activeIndex === k" @click="closeFn" src="../../assets/img/shouqi.png" alt="">
          <img v-else @click="getalbumList(aci, k, false)" src="../../assets/img/zhankan.png" alt="">
        </span>
          <div v-show="activeIndex === k&&aci.list">
            <div class="item-audio" v-for="(item, index) in aci.list" :class="{ 'active': item.isActive}" :key="index">
            <span class="name">
              <span @click="topageDetail(item.id,item,aci,k)">{{item.name}}</span>
            </span>
              <span class="shichang">时长 {{lengthFnn(item.length)}} / {{lengthFnn(item.currentTime)}}</span>
              <span class="btn">
                <template v-if="item.view_pass&&!item.canview">
               <img   src="../../assets/img/doc-lock.png" alt="" @click.stop="inputPass(aci,k)">
                </template>
                <template v-else>
                   <img v-if="!item.palyIng && !item.isActive" @click.stop="playFn(item, index,k)" src="../../assets/img/beforebofang.png" alt="">
                  <img v-if="!item.palyIng && item.isActive" @click.stop="playFn(item, index, k)" src="../../assets/img/bofang.png" alt="">
                  <img v-else @click.stop="pauseFn(item)" src="../../assets/img/zanting.png" alt="">
                </template>

            </span>
            </div>
            <div class="more-tip">
              <span @click="getMore(aci, k)" v-if="aci.list?.length != aci.rows">点击加载更多</span>
              <span v-else>没有更多了</span>
              <!-- ,没有更多了 -->
            </div>
          </div>
        </div>
        <div v-if="isData" class="isData">
          当前页面没有内容或内容已下架
        </div>
      </div>


      <audioBtn
          v-if="audioUrl"
          ref="audioBtn"
          :url="audioUrl"
      >
      </audioBtn>
      <Dialog
          :visible="showDialog"
          title="输入密码，解锁内容"
          @close="showDialog = false"
          @cancel="showDialog = false"
          @confirm="handleConfirm"
      />
    </template>

  </div>
</template>

<script>
import tip from '@/components/tip.vue';
import empty from '@/components/empty.vue'
import audioTitle from '@/components/audioTitle.vue';
import audioBtn from '@/components/audioBtn.vue';
import {Base64} from 'js-base64';
import {Indicator, Toast} from 'mint-ui';
import Vue from 'vue';
import wechat from '@/plugins/wx';
import Dialog from "@/components/dialog.vue";
  export default {
    components: {
      Dialog,
      tip,
      empty,
      audioTitle,
      audioBtn
    },
    data() {
      return {
        aciObj: {},
        audioList: [],
        albumsList: [],
        albumObj: {},
        id: 0,
        // iszhankai: false,
        audioUrl: '',
        palyIng: false,
        timer: null,
        index: 0,
        outIndex: 0,
        playAll: false,
        activeIndex: -1,
        isData: false,
        shareConfig: {
          title: '分享标题',
          desc: '这是一个测试的微信分享',
          link: 'https://example.com', // 分享链接
          imgUrl: 'https://example.com/image.jpg', // 分享图标
        },
        showDialog:false,
        selectAlbum:{},
        selectedIndex:0,
      }
    },
    created () {
      this.id = this.$route.query.id || '811ddaa9-7cee-2fa4-9304-4665c5a8dade'
      this.getaudioList()
      this.report(this.id,3)
    },
    mounted() {
      // 初始化微信 JSSDK 配置
      const currentUrl = window.location.href.split('#')[0];
      wechat.initConfig(currentUrl).then(() => {
        // 配置分享内容
        wechat.setShareOptions(this.shareConfig);
      });
    },
    methods: {
      inputPass(item,k){
        this.selectAlbum = item;
        this.selectedIndex = k
        if(!item.canview&&item.view_pass!=""){
          this.showDialog = true;
          return;
        }
      },
      handleConfirm(value) {
        if(value==this.selectAlbum.view_pass){
          localStorage.setItem(`audioList-auth-${this.selectAlbum.id}`, value);
          this.showDialog = false
          this.albumsList.forEach(item=>{
            if(item.id==this.selectAlbum.id){
              Vue.set(item,"canview",true);
              item.list.forEach(i=>{
                Vue.set(i,"canview",true);
              })
            }
          })
        }else{
          Toast({
            message:'密码不对！',
          });
        }

      },
      toBuy(link){
        window.open(link, '_blank');
      },
      async report(id,dt) {
        try {
          // 发送点击事件请求到服务端
          await this.$report.sendReport({
            "id": id,
            "dt":dt
          });

        } catch (error) {
          console.error("Error sending click request:", error);
        }
      },
      closeFn(){
        this.activeIndex = -1
      },
      topage(){
        this.$router.push(`/audioList?id=${this.$route.query.id}`)
      },
      topageList(id){
        this.$router.push(`/audioList?id=${id}`)
      },
      topageDetail(id,item,album,k){
        if(!item.canview&&item.view_pass!=""){
          this.selectAlbum = album;
          this.selectedIndex = k;
          this.showDialog = true;
          return;
        }
        this.$router.push(`/audioDetail?id=${id}`)
      },
      lengthFnn(duration) {
        let tTime = duration;
        let m = Math.floor(tTime%3600/60);
        let s = Math.floor(tTime%60);
        m = m>=10?m:"0"+m
        s = s>=10?s:"0"+s
        return m+":"+s
      },
      async playBtn(url){
        const res = await this.axios.get(`https://new-videoapi.ayerdudu.com/v1/storage/qiniu/audio/${url}`)
        console.log(res)
      },
      pauseFn(item){
        this.playAll = false
        item.palyIng = false
        this.palyIng = false
        this.$refs.audioBtn.onPause()
        clearInterval(this.timer)
        
      },
      playAllFn(){
        this.playAll = true
        if(this.activeIndex >= 0){
          this.playFn(this.albumsList[this.activeIndex].list[0], 0, this.activeIndex)
        }else{
          this.activeIndex = 0
          this.playFn(this.albumsList[this.activeIndex].list[0], 0, 0)
        }
      },
      // 播放
      async playFn(item, index, k){
        this.selectAlbum = this.albumsList[k]
        this.selectedIndex = k;

        this.index = index
        this.audioUrl = ''
        this.palyIng = true
        this.outIndex = k
        // 清空其他的
        this.albumsList.forEach(n =>{
          n.list.forEach(i =>{
            if(i !== item){
              i.palyIng = false
              i.currentTime = 0
              i.isActive = false
            }
          })
        })
        // 清空其他的
        this.audioList = this.albumsList[k].list || []
        clearInterval(this.timer)
        if(!item.canview&&item.view_pass!=""){
          this.showDialog = true;
          return;
        }
        // 如果是已经播放过的，不需要请求，直接播放
        if(item.audioUrl){
          this.audioUrl = item.audioUrl
          item.palyIng = true
          item.isActive = true
          this.$nextTick(()=>{
            this.$refs.audioBtn.onPlay()
            this.timer = setInterval(() => {
              // 判断超时
              this.toTopFn(item, index, k)
            }, 1000)
          })
        }else{
          // 没有播放过，需要请求一下音频
          try {
            const res = await this.axios.get(`https://api.ayerdudu.com/v1/storage/qiniu/audio/${Base64.encode(item.url)}`)
            this.audioUrl = res.data.data
            item.audioUrl = res.data.data
            item.palyIng = true
            item.isActive = true
            this.$nextTick(()=>{
              if(this.$refs.audioBtn.isOk){
                this.$refs.audioBtn.onPlay()
                this.timer = setInterval(() => {
                  // 判断超时
                  this.toTopFn(item, index, k)
                }, 1000)
              }else{
                const time33 = setInterval(() => {
                  if(this.$refs.audioBtn.isOk){
                    clearInterval(time33)
                    this.$refs.audioBtn.onPlay()
                    this.timer = setInterval(() => {
                      // 判断超时
                      this.toTopFn(item, index, k)
                    }, 1000)
                  }
                }, 300)
              }
            })
          } catch (err) {
            console.log(err)
          }
        }
      },
      toTopFn(item, index, k){
        item.currentTime = Math.round(this.$refs.audioBtn.$refs.audio.currentTime)
        if(item.currentTime >= item.length ){
          clearInterval(this.timer)
          if(this.playAll && index+1 < this.audioList.length){
              this.playFn(this.albumsList[k].list[index+1], index+1, k)
          }else{
            item.currentTime = 0
            item.palyIng = false
            this.playAll = false
            this.palyIng = false
          }
        }
      },
      // 获取合辑数据
      async getaudioList() {
        try {
          Indicator.open()
          this.id = this.$route.query.id || '811ddaa9-7cee-2fa4-9304-4665c5a8dade'
          const response = await this.axios.get(`https://api.ayerdudu.com/v1/album/hj/${this.id}`)
          //const response = await this.axios.get(`http://localhost:8080/v1/album/hj/${this.id}`)
         //
          const res = response.data

          this.aciObj = {
            surface_pic: res.data.pic,
            title: res.data.name,
            author_pic:res.data.user_avatar,
            author_name:res.data.user_name,
            intro: res.data.description,
            audio_totals: res.data.audio_totals,
            enable:res.data.enable,
            buy_link:res.data.buy_link,
            buy_title: res.data.buy_title || "购买此书",
          }
          // 直接赋值数组，而不是逐个push
          this.albumsList = JSON.parse(JSON.stringify(res.data.albums)) || []
          
          // 为每个专辑添加初始属性
          this.albumsList.forEach(item => {
            Vue.set(item, 'rows', item.count)
            const canview = this.$checkViewPass("audioList-auth-"+item.id,item.view_pass);
            item.list?.forEach(i => {
              Vue.set(i, 'currentTime', 0)
              Vue.set(i, 'canview', canview)
            })
            // Vue.set(item, 'list', [])

            Vue.set(item, 'canview', canview)
            Vue.set(item, 'pageNumber', 1)
          })
          
          console.log('结果',this.aciObj)
          console.log(this.albumsList)
          const currentUrl = window.location.href.split('#')[0];
          this.shareConfig.title = this.aciObj.title;
          this.shareConfig.desc = this.aciObj.intro;
          this.shareConfig.link = currentUrl;
          this.shareConfig.imgUrl = this.aciObj.surface_pic;
          console.log('分享配置',this.shareConfig);
          //const currentUrl = 'http://videos.ayerdudu.com/audioDetail?id=d1b469a1-91f4-1400-d29e-241571036c3c';
          wechat.initConfig(currentUrl).then(() => {
            // 配置分享内容
            wechat.setShareOptions(this.shareConfig);
          });
          if(!this.albumsList.length){
            this.isData = true
          }
          Indicator.close()
        } catch (err) {
          console.log(err)
          this.isData = true
          Indicator.close()
        }
      },
      getMore(aci, k ){
        console.log('aci', aci)
        aci.pageNumber++
        this.getalbumList(aci, k, true, true)
      },
      // 获取专辑数据
      async getalbumList(itemList, k, pushArr = false, falg = true) {
        // itemList ,获取id 和 pageNumber
        // k 获取索引
        // pushArr ，判断是打开还是加载更多
        let pageNumber = 1
        if(itemList.pageNumber){
          pageNumber = itemList.pageNumber
        }
        
        // 不再需要检查 list 是否存在，因为我们已经在初始化时创建了它
        
        if(!this.albumsList[k].list?.length || pushArr){
          try {
            //const res = await this.axios.get(`https://new-videoapi.ayerdudu.com/v1/audio/audios?pageNumber=${pageNumber}&pageSize=20&orderField=created_at&sort=asc&albumid=${itemList.id}`)

            //https://api.ayerdudu.com/v1/audio/audios
            const res = await this.axios.get(`https://api.ayerdudu.com/v1/audio/audios?pageNumber=${pageNumber}&pageSize=100&sort=asc&albumid=${itemList.id}`)

            if(pushArr){
              const pushArr = res.data.data
              pushArr.forEach(item => {
                Vue.set(item, 'palyIng', false)
                Vue.set(item, 'currentTime', 0)
                Vue.set(item, 'audioUrl', '')
                Vue.set(item, 'isActive', false)
              })
              this.albumsList[k].list = [...this.albumsList[k].list, ...pushArr]
            }else{
              this.albumsList[k].list = res.data.data
              this.albumsList[k].rows = res.data.rows
              this.albumsList[k].list.forEach(item => {
                Vue.set(item, 'palyIng', false)
                Vue.set(item, 'currentTime', 0)
                Vue.set(item, 'audioUrl', '')
                Vue.set(item, 'isActive', false)
              })
            }
          } catch (err) {
            console.log(err)
          }
        }
        if(falg){
          this.$nextTick(()=>{
            this.activeIndex = k
          })
        }else{
          this.activeIndex = -1
        }
      }
    }
  }
</script>

<style lang="less" scoped>
.album{
  width: 100%;
  min-height: 100%;
  //overflow: hidden;
  //overflow-y: scroll;
  background: #f6f6f6;
  &::-webkit-scrollbar {
    display: none;
  }
  .audioTitle{
    background-color: #fff;
  }
  .conntent{
    padding: 0 40px;
    height: 130px;
    background: #f6f6f6;
  }
}
.video_btnn{
  padding-top: 30px;
  width: 100%;
  height: 70px;
  .video_count{
    float: left;
    font-size: 33px;
    font-weight: bold;
    line-height: 72px;
  }
  .buylink{
    float: right;
    //background-image: linear-gradient(to right, #fe7450 , #f6451b);
    padding: 19px 28px;
    border-radius: 40px;
    color: #f6451b;
    border-color: #f6451b;
    font-size: 22px;
    border: 2px solid #f6451b;
    margin-right: 30px;
    >div{

      >span{
        float: left;
        margin-bottom: -3px;
      }
    }
  }
  .palyall{
    float: right;
    border: 2px solid transparent;
    background-image: linear-gradient(to right, #fe7450 , #f6451b);
    padding: 19px 28px;
    border-radius: 40px;
    color: #fff;
    font-size: 22px;
    >div{
      display: flex;
      align-items: center;
      >img{
        width: 20px;
        height: 26px;
        margin-right: 10px;
      }
      >span{
        display: inline-block;
      }
    }
  }
}
.video-list{
  min-height: 30px;
  padding: 0 18px 100px;
  background: #f6f6f6;
  .item-audio{
    box-sizing: border-box;
    height: 124px;
    position: relative;
    padding: 30px 54px 0;
    .name{
      font-size: 28px;
      display: block;
      color: #000;
      margin-bottom: 5px;
    }
    .shichang{
      font-size: 22px;
      color: #888888;
    }
    .btn{
      position: absolute;
      display: block;
      width: 50px;
      height: 50px;
      overflow: hidden;
      right: 28px;
      top: 45px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    &.active{
      .name{
        color: #f6451b;
      }
      .shichang{
        color: #f6451b;
      }
    }
  }
  .more-tip{
    text-align: center;
    color: #aaa;
    font-size: 22px;
    line-height: 124px;
  }
}
.audio-album{
  min-height: 137px;
  position: relative;
  // box-shadow:2px 2px 1px #aaaaaa;
  border-radius: 20px;
  background: #fff;
  margin-bottom: 20px;
  .album-title{
    font-size: 31px;
    font-weight: bold;
    line-height: 137px;
    text-indent: 30px;
  }
  .album-btn{
    display: block;
    position: absolute;
    top: 50px;
    right: 30px;
    width: 42px;
    height: 42px;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.isData{
  line-height: 100px;
  text-align: center;
  font-size: 30px;
}

</style>
